import React, {Component} from 'react';
import PrintContinuousPaperConfig from './PrintContinuousPaperConfig'

var html2canvas = require('html2canvas')
class PdfContinuousPaper extends Component {
    constructor(...args){
        super(...args)
    
    }

    
    componentDidMount(){
        //this.preview()
        //this.html2canvas()
    }

    onPrintPdf(){
        this.html2canvas()
    }

    html2canvas(){
        var divHeight = '793';
        var divWidth = '1058';
        html2canvas(document.querySelector("#capture"),{height: divHeight,
        width: divWidth}).then(canvas => {
            document.body.appendChild(canvas)
            const imgData = canvas.toDataURL('image/png');
            const pdf = new window.jsPDF("p", "mm", "a4");;
            pdf.addImage(imgData, 'PNG', 0, 0);
            //pdf.save("download.pdf");  

            const file = new Blob(
                [pdf.output('blob')], 
                {type: 'application/pdf'});
          //Build a URL from the file
              const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
              //window.open(fileURL,'','resizable,scrollbars','_blank');
              window.location.replace(fileURL);
        });
    }

    preview(){

        const doc = new window.jsPDF({
            unit: "pt",
            orientation: "p",
            lineHeight: 1.2
        });
        
        // doc.addFont("Arimo-Regular.ttf", "Arimo", "normal");
        // doc.addFont("Arimo-Bold.ttf", "Arimo", "bold");
        // doc.setFont("Arimo");
        // doc.setFontType("normal");
    
        doc.addFont("THSarabunNew.ttf", "THSarabunNew", "normal");
        doc.addFont("THSarabunNew Bold.ttf", "THSarabunNewBold", "bold");
        doc.setFont("THSarabunNew");
        doc.setFontType("normal");
        doc.setFontSize(16);
        
        doc.text("1.Hello, World! ฉันชื่อจักรกริช", 10, 10);
        doc.text("Hello, World! ฉันชื่อจักรกริช", 100, 100);

        doc.text("Hello, World! ฉันชื่อจักรกริช", 100, 150);
        doc.text("Hello, World! ฉันชื่อจักรกริช", 200, 300);
        doc.text("Hello, World! ฉันชื่อจักรกริช", 300, 500);

        doc.text("Hello, World! ฉันชื่อจักรกริช", 100, 800);
        //doc.setFontType("bold");
        
        //doc.text("Hello, BOLD World!", 100, 150);
        
        //doc.save("customFonts.pdf");
        //document.getElementById("pdf_iframe").src = doc.output('datauristring');//Display in iframe
            
    
        const file = new Blob(
            [doc.output('blob')], 
            {type: 'application/pdf'});
      //Build a URL from the file
          //const fileURL = URL.createObjectURL(file);
      //Open the URL on new Window
          //window.open(fileURL,this.props.leftBarTitle,'resizable,scrollbars','_blank');
          //window.location.replace(fileURL);
          
    }

    printDoc() {

          //window.print()   
        // var getMyFrame = document.getElementById("pdf_iframe");
        // getMyFrame.focus();
        // getMyFrame.contentWindow.print();

        
    }
    render(){
        return (
            <div>
                
                <PrintContinuousPaperConfig {...this.props} />
                <button onClick={this.onPrintPdf.bind(this)}>Print</button>
            </div>
                )
    }
}

PdfContinuousPaper.defaultProps = {
    size: 'portrait',  
}

export default PdfContinuousPaper;




// WEBPACK FOOTER //
// ./src/view/print/paperconfig/PdfContinuousPaper.js